export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/index/resources/computed.js